/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import UiJsonApiClient from "../../../Basis/Api/UiJsonApiClient";
import MsClarity from "../Queries/MsClarity";

export default class MsClarityClient extends UiJsonApiClient {
    public constructor() {
        super("msclarity");
    }

    public ladeMsClarity = () => this.get<MsClarity>("ladeMsClarity");
}